import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { EnemySection } from '../components/EnemySection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { BonusSection } from '../components/BonusSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-navy text-white selection:bg-gold selection:text-navy" data-id="element-188">
      <HeroSection data-id="element-189" />
      <PainSection data-id="element-190" />
      <EnemySection data-id="element-191" />
      <SolutionSection data-id="element-192" />
      <WhatInsideSection data-id="element-193" />
      <TestimonialsSection data-id="element-194" />
      <OfferSection data-id="element-195" />
      <BonusSection data-id="element-196" />
      <GuaranteeSection data-id="element-197" />
      <CloseSection data-id="element-198" />
    </main>;
}